export default identifier => `
  {
    filterPage(identifier: "${identifier}") {
      imageUrl
      mobileImageUrl
      explodeVariants

      promoCards {
        id
        isPromoCard
        variant
        text
        ctaText
        targetUrl
        imageUrl
        videoUrl
      }

      subPages {
        title
        description
        filterValues
        imageUrl
        mobileImageUrl
        metaTitle
        metaDescription
      }

      filters {
        id
        title
        order
        level
        type
        values
        excludeIf
        includedInPath
      }

      items {
        id
        name
        summary
        mainVariantId
        price
        filterValues

        variants {
          id
          isBackorderable
          colorName
          productUrl
          imageUrl
          backgroundImageUrl
          backgroundVideoUrl
          colorCodePrimary
          colorCodeSecondary
          skus
          productData
          availabilityDate
          filterValues
          soldItems
        }
      }
    }
  }
`
